/* @flow */
import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import createDebugger from 'debug';
import { querystring } from 'trustar/utils';

const debug = createDebugger('app:modules:subscriptions:epics'); // eslint-disable-line no-unused-vars

import {
  SUBSCRIPTIONS_ENDPOINT,
} from './types.js';

import {
  FETCH_SUBSCRIPTIONS,
  FETCH_SUBSCRIPTIONS_SUCCESS,
  FETCH_SUBSCRIPTIONS_FAILURE,

  UNSUBSCRIBE,
  UNSUBSCRIBE_SUCCESS,
  UNSUBSCRIBE_FAILURE,
} from './action-types.js';

import {
  SUBSCRIBE_SUCCESS,
} from 'modules/data-feeds/action-types.js';

import {
  ACTIVATE_SUCCESS,
} from 'modules/subscription-management/action-types.js';

/** Fetch all Subscriptions a user has access it  */
const fetchSubscriptionsEpic = (action$, store, { ajax }) =>
  action$.ofType(FETCH_SUBSCRIPTIONS, SUBSCRIBE_SUCCESS, UNSUBSCRIBE_SUCCESS, ACTIVATE_SUCCESS)
    .mergeMap(() =>
      ajax.get(`${SUBSCRIPTIONS_ENDPOINT}`)
        .map(({ response }) => ({
          type: FETCH_SUBSCRIPTIONS_SUCCESS,
          payload: response,
        }))
        .catch(err => Observable.of({
          type: FETCH_SUBSCRIPTIONS_FAILURE,
          error: true,
          payload: err,
        })));

/** Unsubscribe to a specific subscription, based on its feedGuid and requiredState (ACTIVE or CANCEL)  */
const unsubscribeEpic = (action$, store, { ajax }) =>
  action$.ofType(UNSUBSCRIBE)
    .mergeMap(({ payload: { guid, requiredState, origin }}) =>
      ajax.post(querystring({ origin, requiredState },`${SUBSCRIPTIONS_ENDPOINT}/${guid}/unsubscribe`))
        .map(({ response }) => ({
          type: UNSUBSCRIBE_SUCCESS,
          payload: response,
          meta: {
            alert: { type: 'success', text: 'Successfully unsubscribed.' },
          },
        }))
        .catch(err => Observable.of({
          type: UNSUBSCRIBE_FAILURE,
          payload: err,
          meta: {
            alert: { type: 'error', text: 'An error occurred while unsubscribing.' },
          },
        })));

export default combineEpics(
  fetchSubscriptionsEpic,
  unsubscribeEpic,
);



// WEBPACK FOOTER //
// ./src/app/modules/subscriptions/epics.js